import api from '@/api/api';
import { toast } from 'react-toastify';

export const getMetrics = async () => {
  try {
    const response = await api.get('/metrics');
    return response.data;
  } catch (error) {
    toast.error('Failed to fetch metrics.');
    throw error;
  }
};
